import React from 'react';
import { useLocation } from 'react-router-dom';
import { useForceLightThemePage } from '../hooks/useForceLightThemePage';
import { isUseCasePath } from '../marketing/use-case-pages';

export const ForceLightThemeOnLanding: React.FC = () => {
  const { pathname } = useLocation();
  useForceLightThemePage(pathname === '/' || isUseCasePath(pathname));
  return null;
};
